(function() {
    'use strict';

    angular
        .module('app.layout')
        .directive('creditCard', creditCard);

    /* @ngInject */
    function creditCard() {
        var directive = {
            bindToController: true,
            templateUrl: "credit-card.tpl",
            controller: creditCardCtrl,
            controllerAs: 'vm',
            link: link,
            restrict: 'E',
            scope: {
                data: '='
            }
        };
        return directive;

        function link(scope, element, attrs) {
            angular.element('.sr-card-element').addClass('ng-invalid');
            window.paymentMethodName = 'card';
            window.card = null;
            scope.loadScript();
        }
    }
    /* @ngInject */
    function creditCardCtrl($scope) {
        $scope.loadScript = function() {
            window.paymentProcessor = $scope.$root.globals.site_options.payment;
            if ($scope.$root.globals.site_options.payment.name == 'square') {
                window.cardStyle = {
                    input: {
                        backgroundColor: '#ececf1',
                        fontSize: Math.round((window.baseFontSize || 14) * 1.25)  + 'px',
                        color: '#36363b'
                    },
                    'input::placeholder': {
                        color: '#36363b'
                    },
                    'input.is-error': {
                        color: '#36363b'
                    },
                    '.input-container': {
                        borderRadius: '0',
                        borderColor: 'transparent',
                        borderWidth: '2px'
                    },
                    '.input-container.is-focus': {
                        borderColor: '#869043',
                        borderWidth: '2px'
                    },
                    '.input-container.is-error': {
                        borderColor: '#ca3c2d',
                        borderWidth: '2px'
                    }
                };
            } else {
                window.cardStyle =  {
                    base: {
                        color: "#36363b",
                        fontFamily: '"Roboto", sans-serif',
                        fontSmoothing: "antialiased",
                        "::placeholder": {
                            color: "#36363b"
                        }
                    },
                    invalid: {
                        fontFamily: '"Roboto", sans-serif',
                        color: "#fa755a",
                        iconColor: "#fa755a"
                    }
                };
            }
            $scope.$root.loadPaymentScript();
        };
    }
})();